var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarehouseProductSortation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M11.2 23.1c-.1 0-.2 0-.3-.1l-8.4-4.9c-.2-.1-.2-.3-.2-.4V8.2c0-.2.1-.3.3-.4s.3-.1.5 0l8.4 5c.2.1.2.3.2.4v9.4c0 .2-.1.3-.3.4-.1.1-.2.1-.2.1m-8-5.7 7.4 4.3v-8.3L3.2 9.1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M11.2 13.7c-.1 0-.2 0-.3-.1l-8.4-5c-.2-.1-.3-.2-.3-.4s.1-.3.3-.4L10.9 3c.2-.1.3-.1.5 0l8.4 4.8c.2 0 .3.2.3.4s-.1.3-.3.4l-8.4 5c-.1.1-.2.1-.2.1M3.7 8.2l7.4 4.4 7.4-4.4L11.1 4z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M15 11.2c-.1 0-.2 0-.3-.1l-7.8-5c-.3-.2-.3-.5-.2-.7s.5-.3.7-.2l7.9 5.1c.2.1.3.5.2.7-.2.2-.3.2-.5.2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M11.2 23.1c-.1 0-.2 0-.2-.1-.2-.1-.3-.3-.3-.4v-9.4c0-.2.1-.3.2-.4l8.4-5c.2-.1.3-.1.5 0 .2 0 .3.2.3.4v5.3c0 .3-.2.5-.5.5s-.5-.2-.5-.5V9.1l-7.4 4.4v8.3l2.4-1.4c.2-.1.5-.1.7.2.1.2.1.5-.2.7l-3.2 1.9c-.1-.1-.2-.1-.2-.1"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M23.7 16.7h-9.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7l-1-1.1c-.2-.2-.2-.5 0-.7s.5-.2.7 0z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M16.6 20.7c-.1 0-.3-.1-.4-.2l-2.5-2.8h9.5c.3 0 .5.2.5.5s-.2.5-.5.5H16l1 1.1c.2.2.2.5 0 .7-.1.2-.3.2-.4.2"
})));
export default SvgWarehouseProductSortation;